import styled, { keyframes } from 'styled-components'

const backdropVideoIn = keyframes`
  from {
    opacity: 0;
    transform: scale(1.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  overflow: hidden;
  box-sizing: border-box;
`

export const ModalScrollLayer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 1em;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`

export const ModalScrollCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
`

export const ModalBackdropVideo = styled.video`
  position: fixed;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  opacity: 0;
  transform: scale(1.5);
  transform-origin: center center;
  animation: ${backdropVideoIn} 1s ease 0.5 forwards;
`

export const ModalBackdropScrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1;
  background: black;
  pointer-events: none;
`

export const show = keyframes`
  from {
    transform: scale(0.95);
    opacity: 0.85;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`

export const ModalContent = styled.div`
  width: 100%;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  background-color: #000000;
  border: 1px solid #414244;
  min-height: 180px;
  animation: 370ms ease ${show} forwards;
  border-radius: 0.5em;
  overflow: visible;
  position: relative;
  flex-shrink: 0;
`

export const ModalBar = styled.div`
  font-size: 1.1em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.3em;
  position: relative;
  font-weight: bold;
  font-family: 'Chivo', sans-serif;
  font-style: italic;
  background: linear-gradient(rgba(42, 42, 42, 0.8), #000000);
  flex-shrink: 0;
`

export const ModalCloseButton = styled.button`
  border: 0;
  outline: 0;
  background: transparent;
  color: #fff;
  font-size: 1.3em;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    opacity: 0.7;
  }
`

export const ModalInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: visible;
`
